export const congNo = {
  title: 'Công nợ',
  titles: {
    list: 'Báo cáo tổng hợp công nợ',
    customers: 'Công nợ khách hàng',
    invoices: 'Công nợ theo đơn',
    invoiceLines: 'Công nợ theo đơn chi tiết',
    payments: 'Thanh toán',
    refunds: 'Hoàn tiền',
    detail: 'Chi tiết công nợ khách hàng',
  },
  fields: {
    invoiceCode: 'Mã hóa đơn',
    productCode: 'Mã hàng',
    productName: 'Tên hàng',
    unit: 'ĐVT',
    quantity: 'SL',
    unitPrice: 'Đơn giá',
    lineDiscount: 'Giảm giá',
    lineAmount: 'Thành tiền',
    orderDiscount: 'Giảm chung',
    otherIncome: 'Thu khác',
    tax: 'Thuế',
    debtAmount: 'Công nợ',
    voucherCode: 'Mã chứng từ',
    voucherType: 'Loại chứng từ',
    customerCode: 'Mã KH',
    maNhanVienPhuTrach: 'NVKD phụ trách',
    customerName: 'Khách hàng',
    supplierCode: 'Mã NCC',
    supplierName: 'Nhà cung cấp',
    totalReceivable: 'Phải thu',
    openingDebt: 'Nợ đầu kỳ',
    invoiceReceivable: 'Phải thu trên HĐ',
    invoicePaid: 'Đã thu trên HĐ',
    totalPaid: 'Đã thu',
    totalOtherCost: 'Chi phí khác',
    totalDeduction: 'Khấu trừ',
    totalOpeningAdjust: 'Cân bằng CN + Khởi tạo CN đầu vào',
    totalTaxAdvance: 'Tạm ứng thuế',
    totalRefund: 'Hoàn tiền',
    totalSalesReturn: 'Trả hàng',
    balance: 'Còn nợ',
    balancePayable: 'Còn phải trả',
    phone: 'Điện thoại',
    branch: 'Chi nhánh',
    time: 'Thời gian',
    paymentMethod: 'Phương thức',
    amount: 'Số tiền',
    note: 'Ghi chú',
    returnCode: 'Mã phiếu trả',
    refundDue: 'Cần trả khách',
    refundPaid: 'Đã trả khách',
    refundRemain: 'Còn phải trả',
    actions: 'Thao tác',
    dinhMucCongNo: 'Định mức công nợ',
    ngayCanDoiNo: 'Ngày cần đòi nợ',
    canhBaoCongNo: 'Cảnh báo đòi nợ',
  },
  canhBao: {
    vuotDinhMuc: 'Vượt định mức',
    quaHan: 'Quá hạn {count} ngày',
    sapDenHan: 'Còn {count} ngày',
    trongHan: 'Trong hạn',
    denHanHomNay: 'Đến hạn hôm nay',
  },
  hanDoiNo: {
    hangThang: 'Ngày {day} hàng tháng',
    kyNay: 'Hạn kỳ này: {date}',
  },
  list: {
    rowClickExpand: 'Nhấn dòng để xem / ẩn chi tiết công nợ',
  },
  tabs: {
    customers: 'CN khách hàng',
    invoices: 'CN theo đơn',
    invoiceLines: 'CN chi tiết',
    payments: 'GD thanh toán',
    refunds: 'GD hoàn tiền',
  },
  actions: {
    viewDetail: 'Xem chi tiết',
    viewReturn: 'Xem phiếu trả',
    detail: 'Chi tiết',
    exportExcel: 'Xuất Excel',
    exportAllSheets: 'Xuất tất cả',
    exportAllSheetsHint: 'Xuất đủ 5 sheet: Tổng hợp, Hóa đơn, Thanh toán, Hoàn tiền, Lịch sử chốt',
    chot: 'Chốt công nợ',
    paymentTerms: 'Điều khoản thanh toán',
    chotHistory: 'Lịch sử chốt',
    lock: 'Khóa',
    unlock: 'Mở khóa',
  },
  filter: {
    searchPlaceholder: 'Tìm theo tên / mã khách hàng',
    searchPlaceholderDon: 'Tìm theo mã chứng từ / mã KH',
    searchPlaceholderDonChiTiet: 'Tìm theo mã chứng từ / KH / mã, tên hàng',
    searchPlaceholderPayment: 'Tìm theo mã / tên khách hàng, ghi chú',
    searchPlaceholderRefund: 'Tìm theo mã KH / tên khách / ghi chú',
    fromDate: 'Từ ngày',
    toDate: 'Đến ngày',
    textDetailTitle: 'Bộ lọc chi tiết',
  },
  filters: {
    hintSection: 'Gợi ý',
    hintBody: 'Dùng ô tìm kiếm để lọc nhanh theo tên / mã khách hàng hoặc nhà cung cấp.',
    all: 'Tất cả',
    dateSection: 'Thời gian',
    dateRangePlaceholder: 'Chọn khoảng thời gian',
    fromDate: 'Từ ngày',
    toDate: 'Đến ngày',
    debtSection: 'Tình trạng công nợ',
    debtAll: 'Tất cả',
    debtOutstanding: 'Còn nợ (≠ 0)',
    debtCleared: 'Hết nợ (= 0)',
    canhBaoSection: 'Cảnh báo đòi nợ',
    canhBaoCanDoi: 'Cần đòi nợ (vượt mức hoặc đến hạn)',
    canhBaoVuotDinhMuc: 'Vượt định mức',
    canhBaoQuaHan: 'Quá hạn đòi nợ',
    customerTypeSection: 'Loại khách hàng',
    groupSection: 'Nhóm khách hàng',
    voucherTypeInvoice: 'Hóa đơn',
    voucherTypeReturn: 'Trả hàng',
    debtRangeSection: 'Khoảng còn nợ',
    debtFrom: 'Từ',
    debtTo: 'Đến',
    transactionTypeSection: 'Loại giao dịch',
    lockSection: 'Khóa sửa',
    locked: 'Đã khóa',
    unlocked: 'Chưa khóa',
    sortSection: 'Sắp xếp',
    sortField: 'Sắp xếp theo',
    sortDir: 'Thứ tự',
    nhanVienPhuTrachPlaceholder: 'Nhập mã nhân viên',
  },
  loai: {
    caNhan: 'Cá nhân',
    congTy: 'Tổ chức/ Hộ kinh doanh',
  },
  sort: {
    maKhachHang: 'Mã khách hàng',
    tenKhachHang: 'Tên khách hàng',
    maHoaDon: 'Mã hóa đơn',
    maPhieuTraHang: 'Mã phiếu trả',
    soTien: 'Số tiền',
    thoiGian: 'Thời gian',
    maNhaCungCap: 'Mã nhà cung cấp',
    tenNhaCungCap: 'Tên nhà cung cấp',
    conNo: 'Còn nợ',
  },
  aria: {
    columnPicker: 'Chọn cột hiển thị',
  },
  detail: {
    invoiceReturn: 'Trả hàng',
    invoiceRemaining: 'Còn nợ HĐ',
    openingBalance: 'Dư đầu kỳ',
    closingBalance: 'Dư cuối kỳ',
    tabSummary: 'Tổng hợp',
    tabReceivable: 'Hóa đơn',
    tabPayment: 'Thanh toán',
    tabTransaction: 'Giao dịch',
    tabRefund: 'Hoàn tiền',
    tabChotHistory: 'Lịch sử chốt',
    rowKindInvoice: 'Hóa đơn',
    rowKindPayment: 'Thanh toán',
    rowKindRefund: 'Hoàn tiền',
    rowKindTransaction: 'Giao dịch',
    openingAdjust: 'CB + KT công nợ',
    receivingAccount: 'Tài khoản nhận tiền',
    otherCost: 'Chi phí khác',
    deduction: 'Khấu trừ',
    paid: 'Đã thanh toán',
    taxAdvance: 'Tạm ứng thuế',
    paymentImages: 'Ảnh nhận tiền',
    refundImages: 'Ảnh trả tiền',
    congVaoCongNo: 'Cộng vào công nợ',
    truDiCongNo: 'Trừ đi công nợ',
    notFound: 'Không tìm thấy khách hàng.',
    loadError: 'Không tải được chi tiết công nợ.',
    filterInvoiceSearch: 'Tìm mã hóa đơn',
    filterBranchAll: 'Tất cả chi nhánh',
    filterClear: 'Xóa lọc',
  },
  transaction: {
    overpayTitle: 'Số tiền vượt công nợ',
    overpayConfirm:
      'Số tiền {soTien} lớn hơn công nợ còn lại {conNo}. Sau giao dịch, công nợ của khách sẽ âm (khách trả dư). Vẫn lưu?',
    add: 'Thêm giao dịch',
    create: 'Tạo giao dịch công nợ',
    edit: 'Sửa giao dịch',
    date: 'Ngày giờ giao dịch',
    type: 'Loại',
    amount: 'Số tiền',
    phanBo: {
      title: 'Phân bổ vào hóa đơn',
      hint: 'Tự chia từ đơn xa nhất → gần nhất. Tick «Khóa» hoặc sửa số tiền để giữ đúng số cho đơn đó; phần còn lại tiếp tục chia ngầm.',
      empty: 'Không có hóa đơn còn nợ để phân bổ.',
      loadFailed: 'Không tải được danh sách hóa đơn còn nợ.',
      lock: 'Khóa',
      tongPhanBo: 'Đã phân bổ',
      conLai: 'Chưa phân bổ',
    },
    description: 'Nội dung',
    runningBalance: 'Số dư sau GD',
    deductionCategory: 'Lý do khấu trừ',
    images: 'Ảnh chứng từ',
    deleteConfirm: 'Xóa giao dịch công nợ này?',
    sections: {
      images: 'Ảnh nhận tiền',
      refundImages: 'Ảnh hoàn tiền cho khách',
    },
    canHoanTienChoKhach: 'Cần hoàn tiền cho khách',
    soTienNhan: 'Số tiền nhận',
    soTienThuHo: 'Số tiền thu hộ',
    thuHoCho: 'Thu hộ cho',
    soTienCanHoan: 'Số tiền cần hoàn',
    congTyNhanTien: 'Tài khoản nhận tiền',
    congTyNhanTienPlaceholder: 'Chọn tài khoản quỹ / ngân hàng của công ty',
    congTyNhanTienHint:
      'Chọn sổ quỹ để hệ thống tự tạo phiếu thu (loại thu chi: Giao dịch thanh toán)',
    taiKhoanChiHoanTien: 'Quỹ chi hoàn tiền',
    taiKhoanChiHoanTienPlaceholder: 'Chọn quỹ để trừ tiền',
    taiKhoanChiHoanTienHint:
      'Bắt buộc — hệ thống tạo phiếu chi đã duyệt và trừ quỹ ngay',
    congTyChuyenTien: 'Cty chuyển tiền',
    soTienCanHoanHint: 'Tự tính: Số tiền nhận − Số tiền thanh toán − Số tiền thu hộ',
    ghiChuHoanTien: 'Ghi chú hoàn tiền',
    refundStatus: 'Trạng thái hoàn',
    refundPartial: 'Hoàn 1 phần',
    refundDone: 'Đã hoàn',
    refundStatuses: {
      CHUA_HOAN: 'Chưa hoàn',
      HOAN_MOT_PHAN: 'Hoàn 1 phần',
      DA_HOAN: 'Đã hoàn',
    },
    types: {
      THANH_TOAN: 'Thanh toán',
      HOAN_TIEN: 'Hoàn tiền',
      CHI_PHI_KHAC: 'Chi phí khác',
      KHAU_TRU: 'Khấu trừ',
      TAM_UNG_THUE: 'Tạm ứng thuế',
      CAN_BANG: 'Cân bằng công nợ',
      KHOI_TAO: 'Khởi tạo công nợ',
    },
    signedAmountHint: 'Dương tăng nợ, âm giảm nợ, khác 0.',
    deductionCategories: {
      GIAM_GIA: 'Giảm giá',
      HANG_LOI: 'Hàng lỗi / hỏng',
      SAI_GIA: 'Sai giá',
      KHAC: 'Khác',
    },
    imagesUpload: {
      pickImage: 'Chọn ảnh',
      pasteImage: 'Dán ảnh',
      uploading: 'Đang tải ảnh...',
      uploadError: 'Tải ảnh thất bại',
      pasteImageNoImage: 'Clipboard không có ảnh.',
      dragDropHint: 'Kéo thả ảnh vào đây hoặc nhấp để chọn',
    },
  },
  importKhoiTao: {
    perCustomerHint:
      'Mỗi khách chỉ nhận số dư đầu khi ngày khởi tạo trước mọi hóa đơn, phiếu trả và giao dịch của chính khách đó. Dương tăng nợ, âm giảm nợ.',
    sampleCode: 'MA_KHACH_HANG',
    open: 'Import số dư đầu',
    title: 'Import khởi tạo công nợ',
    description:
      'File Excel 2 cột: mã khách hàng, số tiền (dương tăng nợ, âm giảm nợ). Số tiền là số nguyên (VND). Ngày giao dịch chung cho mọi dòng.',
    date: 'Ngày giờ khởi tạo',
    colCustomerCode: 'Mã khách hàng',
    colAmount: 'Số tiền',
    templateFileName: 'mau-import-khoi-tao-cong-no.xlsx',
    noSheet: 'Không tìm thấy sheet trong file Excel.',
    noData: 'File Excel không có dòng dữ liệu hợp lệ.',
    readError: 'Không đọc được file Excel.',
    invalidSummary: '{count} dòng không hợp lệ. Sửa file rồi chọn lại.',
    errMissingCode: 'Thiếu mã khách hàng',
    errMissingAmount: 'Thiếu số tiền',
    errInvalidAmount: 'Số tiền không hợp lệ: {raw}',
    errZeroAmount: 'Số tiền phải khác 0',
    errFractionalAmount: 'Số tiền phải là số nguyên (VND), không có phần lẻ: {raw}',
    errDuplicate: 'Trùng mã khách hàng trong file',
    hint: 'Ngày phải trước mọi hóa đơn, phiếu trả và giao dịch đã có. Dương tăng nợ, âm giảm nợ.',
    submit: 'Import',
    empty: 'Chưa có dòng hợp lệ.',
  },
  chotAll: {
    open: 'Chốt toàn bộ',
    title: 'Chốt công nợ toàn bộ khách hàng',
    hint: 'Chốt mọi khách đang hoạt động đến cuối ngày đã chọn. Kỳ đã chốt sẽ khóa hóa đơn, phiếu trả và giao dịch công nợ.',
    submit: 'Chốt toàn bộ',
    confirm:
      'Chốt công nợ của tất cả khách hàng đang hoạt động đến hết ngày {date}? Sau khi chốt, hóa đơn, phiếu trả và giao dịch trong kỳ sẽ bị khóa.',
    resultSummary: 'Đã chốt {ok}/{total} khách hàng. {fail} khách hàng chốt lỗi:',
  },
  chot: {
    title: 'Chốt công nợ',
    note: 'Ghi chú',
    submit: 'Xác nhận chốt',
    closeDate: 'Ngày chốt',
    snapshotHint:
      'Số liệu hiển thị là công nợ hiện tại. Kỳ chốt tính nối tiếp từ sau lần chốt gần nhất đến hết ngày chốt; hệ thống tự tính số tiền (không nhập tay).',
    confirm:
      'Chốt công nợ của khách hàng này đến hết ngày {date}? Sau khi chốt, hóa đơn, phiếu trả và giao dịch trong kỳ sẽ bị khóa.',
  },
  chotHistory: {
    title: 'Lịch sử chốt công nợ',
    closedAt: 'Thời điểm chốt',
    period: 'Kỳ',
    note: 'Ghi chú',
    cancelled: 'Đã hủy',
  },
  paymentTerms: {
    title: 'Cập nhật thời gian thanh toán',
    days: 'Số ngày thanh toán',
  },
  messages: {
    noData: 'Không có dữ liệu',
    loadError: 'Không tải được danh sách công nợ.',
    listSummary: 'Tổng {count} khách hàng',
    listSummaryDon: 'Tổng {count} chứng từ',
    listSummaryDonChiTiet: 'Tổng {count} dòng hàng',
    listSummaryPayment: 'Tổng {count} giao dịch công nợ',
    listSummaryRefund: 'Tổng {count} giao dịch hoàn tiền',
    noTransactions: 'Chưa có giao dịch trên timeline',
    noChotHistory: 'Chưa có lịch sử chốt',
    invalidType: 'Loại giao dịch không hợp lệ.',
    invalidDeductionCategory: 'Chọn lý do khấu trừ.',
    invalidAmount: 'Số tiền không hợp lệ.',
    invalidDate: 'Chọn ngày giao dịch.',
    futureDate: 'Thời điểm giao dịch không được ở tương lai.',
    futureCloseDate: 'Ngày chốt không được ở tương lai.',
    amountMustBePositive: 'Số tiền phải lớn hơn 0.',
    refundFundRequired: 'Hoàn tiền bắt buộc chọn quỹ để tạo phiếu chi.',
    receivedAmountRequired: 'Vui lòng nhập số tiền nhận.',
    refundAmountRequired: 'Số tiền cần hoàn phải lớn hơn 0 (Số tiền nhận − Số tiền thanh toán − Số tiền thu hộ).',
    chotSuccess: 'Đã chốt công nợ.',
    chotAllSuccess: 'Đã chốt {ok}/{total} khách hàng.',
    huyChot: 'Hủy chốt',
    huyChotConfirm: 'Hủy lần chốt gần nhất? Các chứng từ sau ngày chốt trước đó sẽ được sửa lại.',
    huyChotSuccess: 'Đã hủy lần chốt.',
    importSuccess: 'Import khởi tạo: {ok} thành công, {fail} lỗi.',
    lockSuccess: 'Đã khóa giao dịch.',
    lockConfirm: 'Khóa giao dịch này? Giao dịch đã khóa không sửa / xóa được cho tới khi mở khóa.',
    unlockConfirm: 'Mở khóa giao dịch này để cho phép sửa / xóa?',
    unlockSuccess: 'Đã mở khóa giao dịch.',
    lockedNeedUnlock: 'Giao dịch đang khóa — mở khóa trước khi sửa hoặc xóa.',
  },
}
